import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Progress } from "@shared/ui/progress";
import { Building, MapPin } from "lucide-react";

export const FacilityPerformanceSection: React.FC<{ data: any }> = ({ data }) => {
  const getStatusVariant = (status: string) => {
    switch (status) {
      case "compliant":
      case "on-track":
      case "resolved":
        return "outline";
      case "warning":
      case "behind":
      case "investigating":
        return "secondary";
      case "violation":
      case "overdue":
      case "critical":
      case "active":
        return "destructive";
      default:
        return "outline";
    }
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center space-x-2 text-base">
          <Building className="h-5 w-5 text-blue-600" />
          <span>Facility Performance Summary</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-2 gap-4">
          {data?.facilityPerformanceSummary?.map((facility, index) => (
            <div
              key={index}
              className="p-4 rounded border hover:bg-muted/20 transition-colors"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-2">
                  <Building className="h-4 w-4 text-blue-600" />
                  <h3 className="font-medium text-sm">{facility.name}</h3>
                </div>
                <Badge
                  variant={getStatusVariant(facility.status)}
                  className="text-xs"
                >
                  {facility.status?.toUpperCase()}
                </Badge>
              </div>

              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <MapPin className="h-3 w-3 text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">
                    {facility.location}
                  </span>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-xs text-muted-foreground">
                    Compliance Score
                  </span>
                  <span className="text-sm font-medium">
                    {facility.complianceScore}%
                  </span>
                </div>
                <Progress value={facility.complianceScore} className="h-2" />

                <div className="grid grid-cols-2 gap-2 text-xs">
                  <div>
                    <span className="text-muted-foreground">Capacity:</span>
                    <span className="font-medium ml-1">
                      {facility.capacity}
                    </span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">Violations:</span>
                    <span
                      className={`font-medium ml-1 ${
                        facility.violations > 0
                          ? "text-red-600"
                          : "text-green-600"
                      }`}
                    >
                      {facility.violations}
                    </span>
                  </div>
                </div>

                <div className="text-xs text-muted-foreground">
                  Last Inspection: {facility.lastInspection}
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};